 {
    "common": {
    "thisWeek": "Den här veckan",
    "lastWeek": "Förra veckan",
    "lastNumberOfDays": "Senaste {numberOfDays} dagarna",
    "thisMonth": "Den här månaden"
    },
    "subAccounts": "Underkonton",
    "submitFeedback": "Skicka feedback",
    "createSubAccount": "Skapa ett underkonto",
    "viewScheduleReports": "Visa schemalagda rapporter",
    "searchSubAccount": "Sök efter underkonto",
    "columns": "Kolumner",
    "sortBy": "Sortera efter",
    "selectColumns": "Välj kolumner",
    "maxColumns": "Max 8 kolumner vid ett datum",
    "applyColumns": "Använd kolumner",
    "activeUsers": "Aktiva användare",
    "appointments": "Möten",
    "contacts": "Kontakter",
    "emails": "Gmail",
    "textMessages": "Brödtextmeddelanden",
    "calls": "Samtal",
    "submissions": "Inlämningar",
    "reviews": "Recensioner",
    "sitesCreated": "Skapade webbplatser",
    "name": "Namn",
    "formSubmissions": "Inlämnade formulär",
    "surveySubmissions": "Inlämnade undersökningar",
    "facebookFormSubmissions": "Inlämnade Facebook-formulär",
    "funnels": "Trattar",
    "websites": "Webbplatser",
    "forms": "Formulär",
    "surveys": "Undersökningar",
    "highestFirst": "Max först",
    "lowestFirst": "Lägst först",
    "orderBy": "Sortera Via",
    "noMoreLocations": "Inget mer Adress hittades",
    "preparingReport": "Vi förbereder din rapport ...",
    "preparingReportDesc": "Stäng inte eller uppdatera det här fönstret medan exporten pågår.",
    "outOf": "Från",
    "subAccountsExported": "Underkonton har exporterats",
    "close": "Stäng",
    "scheduledForDeletion": "Schemalagd för radering",
    "readyToSell": "Redo att sälja",
    "closedWon": "Stängd (vunnen)",
    "wpSaleSuccessful": "WordPress-försäljningen har genomförts",
    "wpNotSold": "WordPress är inte såld än",
    "yxtSaleSuccessful": "Nästa försäljning är framgångsrik",
    "yxtNotSold": "Ännu inte såld",
    "saasSubInactive": "SaaS Abonnemang är Inaktiv",
    "saasSubTrialing": "SaaS Abonnemang testar",
    "saasSubActive": "SaaS Abonnemang är Dynamisk",
    "emailRebillingActive": "E-post Återfakturering är Dynamisk",
    "emailRebillingInactive": "E-post Återfakturering är Inaktiv",
    "twilioRebillingActive": "Twilio Återfakturering är Dynamisk",
    "twilioRebillingInactive": "Twilio Återfakturering är Inaktiv",
    "wpRebillingActive": "Återfakturering via WhatsApp är aktiv",
    "wpRebillingInactive": "Återfakturering via WhatsApp är inaktiv",
    "saasModeActivated": "SaaS läget är Aktiverad",
    "paymentPending": "Betalning väntar",
    "saasModeNotActivated": "SaaS läget är inte Aktiverad",
    "managedByLCPhone": "Hantera Via LC Telefon",
    "migrationToLCPhone": "Under migrering till LC Telefon",
    "notManagedByLCPhone": "Inte Hantera Via LC Telefon",
    "managedByLCEmail": "Hantera Via LeadConnector Email System",
    "notMangedByLCEmail": "Inte Hantera Via LeadConnector Email System",
    "remainingWalletBalance": "Återstående saldo i plånboken för denna SaaS-plats",
    "reports": "Rapporter",
    "switchToSubAccount": "Byt till underkonto",
    "manageClient": "Hantera kund",
    "subAccountDeletedIfChangedMind": "Det här underkontot kommer att raderas på {time}, om du har ändrat dig",
    "subAccountDeletedInMinute": "Det här underkontot kommer att raderas inom en minut",
    "changedMind": "Om Du've Dynamisk your mind",
    "clickHere": "klicka här",
    "subAccountPaused": "Det här underkontot är pausat. Dina kunder kan inte logga in, men byrån kan det. För att återuppta det här kontot",
    "subAccountRestricted": "Det här underkontot är pausat eftersom det väntar på godkännande.",
    "subAccountVerificationPending": "Det här underkontot är pausat eftersom det väntar på att underkontoadministratören verifierar e-post och telefon.",
    "subAccountDeclined": "Det här underkontot är pausat på grund av avböjd förfrågan om godkännande. Du kan fortfarande återuppta det här underkontot från ",
    "here": "här.",
    "reviewAndResume": "för att granska och återuppta det här underkontot.",
    "incomingCalls": "Inkommande samtal",
    "outgoingCalls": "Utgående samtal",
    "totalTalktime": "Totalt taltid",
    "incomingEmails": "Inkommande Gmail",
    "outgoingEmails": "Utgående Gmail",
    "incomingSms": "Inkommande Brödtextmeddelanden",
    "outgoingSms": "Utgående Brödtextmeddelanden",
    "contactsCreated": "Totalt antal kontakter skapade",
    "appointmentsBooked": "Totalt antal bokade möten",
    "totalFormSubmissions": "Totalt Formulär-inlämningar",
    "totalSurveySubmissions": "Totalt Undersöknings inlämningar",
    "totalFacebookFormSubmissions": "Totalt inlämningar av Facebook-formulär",
    "incomingGMBMessages": "Inkommande GBP-meddelanden",
    "outgoingGMBMessages": "Utgående GBP-meddelanden",
    "gmbMessages": "GBP-meddelanden",
    "fbMessages": "Facebook-meddelanden",
    "incomingFbMessages": "Inkommande Facebook-meddelanden",
    "outgoingFbMessages": "Utgående Facebook-meddelanden",
    "igMessages": "Instagram-meddelanden",
    "incomingIgMessages": "Inkommande Instagram-meddelanden",
    "outgoingIgMessages": "Utgående Instagram-meddelanden",
    "totalReviews": "Totalt recensioner",
    "positiveReviews": "Positiva recensioner",
    "negativeReviews": "Negativa recensioner",
    "back": "Tillbaka",
    "selectDashboards": "Välj instrumentpaneler",
    "next": "Nästa",
    "backToSubAccounts": "Tillbaka till underkonton",
    "pauseSchedule": "Pausa schema",
    "resumeSchedule": "Återuppta schema",
    "editSchedule": "Redigera schema",
    "addSchedule": "Lägg till schema",
    "selectReportToAdd": "Välj rapporterar till Inkludera in E-posten",
    "selectAll": "Välj varje",
    "pauseScheduleConfirm": "Är du säker på att du vill pausa rapportschemat?",
    "resumeScheduleConfirm": "Är du säker på att du vill Återuppta rapportschemat?",
    "tasks": "Uppgifter",
    "conversations": "Konversationer",
    "users": "Användare",
    "dealOverview": "Avtal Översikt",
    "confirmAction": "Bekräfta åtgärden",
    "yes": "Ja",
    "no": "Nej",
    "reportDetails": "Rapportdetaljer",
    "reportCreatedOn": "Rapport Skapad På",
    "searchByEmail": "Sök Via e-post",
    "lastActivity": "Senaste aktivitet",
    "noRecords": "Inga poster hittades",
    "scheduleReport": "Schemalägg rapport",
    "schedule": "schema",
    "save": "Spara",
    "emailSubject": "Ämnesrad",
    "frequency": "Frekvens",
    "daily": "Dagligen",
    "weekly": "Varje vecka",
    "monthly": "Varje månad",
    "nextScheduleDate": "Nästa schema Datum",
    "startingOn": "Startar På",
    "timeOfDay": "Datum av Dag",
    "reportsToTimezone": "Rapporten skickas i underkontots tidszon",
    "selectRecipients": "Välj mottagare",
    "invalidEmail": "Ange en giltig e-postadress.",
    "testEmail": "Test e-post",
    "selectTestRecipients": "Välj Test",
    "setupSubject": "Konfigurera Ämne ovan för att Test rapporten",
    "sendTest": "Ladda upp Test",
    "scheduleSimilarSchedules": "Schemalägg en liknande rapport för andra underkonton",
    "accountSummary": "Kontosammanfattning",
    "scheduleList": "Schemalagda rapporter",
    "subAccountName": "Namn på underkonto",
    "nextRunDate": "Nästa körningsdatum",
    "reportSectionsAdded": "Rapportavsnitt har lagts till",
    "status": "Status",
    "scheduleAction": "Schemalägg åtgärd",
    "cancel": "Avbryt",
    "pleaseWait": "Laddar …",
    "confirm": "Bekräfta",
    "booked": "Bokad",
    "confirmed": "Bekräftad",
    "showed": "Deltog",
    "noShow": "Uteblev",
    "cancelled": "Avbokad",
    "unread": "Oläst",
    "engagement": "Engagemang",
    "reaction": "Reaktion",
    "deliverySummary": "Sammanfattning av leverans",
    "successfulDelivery": "Leverans genomförd",
    "opened": "Öppnad",
    "clicked": "Klickad",
    "replied": "Svarade",
    "unsubscribed": "Avprenumererade",
    "complained": "Klagade",
    "failed": "Misslyckad",
    "bounced": "Studsade",
    "open": "Öppen",
    "won": "Vunnen",
    "abandoned": "Övergiven",
    "lost": "Förlorad",
    "sent": "Skickat",
    "eject": "Mata ut",
    "delivered": "Levererad",
    "faceBookLeadForm": "Formulär för potentiell kund från Facebook",
    "overdue": "Förfallna",
    "reviewsReceived": "Recensioner Mottagen",
    "formBuilders": "Formulärbyggare",
    "switchToSaaS": "Byt till SaaS",
    "numberOfContacts": "Totalt antal kontakter",
    "numberOfAppointments": "Totala möten",
    "outreach": "Uppsökande verksamhet",
    "notSubAccountUser": "Använder inte ett underkonto",
    "searchSubAccName": "Sök efter namn på underkonto",
    "recipients": "Mottagare",
    "scheduleCreated": "Schema för e-postrapport har skapats för ",
    "scheduleUpdated": "Schema för e-postrapport har uppdaterats för ",
    "scheduleNotCreated": "Schema för e-postrapport kunde inte skapas för",
    "scheduleNotUpdated": "Schema för e-postrapport kunde inte uppdateras för",
    "total": "Totalt",
    "inbound": "Inkommande",
    "outbound": "Utgående",
    "totalEmails": "Totalt antal e-postmeddelanden",
    "inboundEmails": "Inkommande e-post",
    "outboundEmails": "Utgående e-postmeddelanden",
    "totalTextMessages": "Totalt antal sms",
    "inboundTextMessages": "Inkommande sms",
    "outboundTextMessages": "Utgående sms",
    "totalCalls": "Totalt antal samtal",
    "inboundCalls": "Inkommande samtal",
    "outboundCalls": "Utgående samtal",
    "faceBookLeadFormSubmissions": "Inlämnade Facebook-formulär för potentiella kunder",
    "inboundGMBMessages": "Inkommande GBP-meddelanden",
    "outboundGMBMessages": "Utgående GBP-meddelanden",
    "totalIgMessages": "Totalt antal Instagram-meddelanden",
    "inboundIgMessages": "Inkommande Instagram-meddelanden",
    "outboundIgMessages": "Utgående Instagram-meddelanden",
    "totalfbMessages": "Totalt antal Facebook-meddelanden",
    "inboundfbMessages": "Inkommande Facebook-meddelanden",
    "outboundfbMessages": "Utgående Facebook-meddelanden",
    "sitesCreatedFunnels": "Skapade webbplatser - trattar",
    "sitesCreatedActiveFunnels": "Skapade webbplatser – aktiva trattar",
    "sitesCreatedWebsites": "Skapade webbplatser – webbplatser",
    "sitesCreatedActiveWebsites": "Skapade webbplatser - aktiva webbplatser",
    "sitesCreatedForms": "Skapade webbplatser – formulär",
    "sitesCreatedActiveForms": "Skapade webbplatser – aktiva formulär",
    "sitesCreatedSurveys": "Skapade webbplatser – undersökningar",
    "sitesCreatedActiveSurveys": "Skapade webbplatser – aktiva undersökningar",
    "googleReviews": "Google-recensioner",
    "facebookReviews": "Facebook-recensioner",
    "inboundCallDuration": "Inkommande samtals varaktighet (timmar)",
    "outboundCallDuration": "Varaktighet för utgående samtal (timmar)",
    "pleaseSelect": "Välj",
    "subAccountIsDeleted": "Det här underkontot har raderats",
    "subAccountIsPaused": "Det här underkontot har pausats",
    "success": "Klart",
    "error": "Fel",
    "testEmailSent": "Test E-post skickade",
    "testEmailNotSent": "Test E-post kunde inte skickas",
    "reviewRequest": "Recensionsförfrågan",
    "pendingTransferDescription": "Andra byråer har bett om att få överföra underkonton till dig.",
    "pendingTransferHeading": "Du har väntande förfrågningar om överföring av underkonton.",
    "subAccountTransfer": "Överföring av underkonton",
    "manageSubAccTransfer": "Hantera dina förfrågningar om överföring av underkonton",
    "subAccRequest": "Förfrågningar om {tabName} av underkonton",
    "receive": "Ärv",
    "send": "Skicka",
    "release": "Version",
    "requests": "{count} förfrågningar",
    "subAccLimit": "Gränsen för användning av underkonton har nåtts.",
    "subAccPlanLimit": "Du har använt de 3/3 underkonton som är tillåtna enligt ditt nuvarande abonnemang.",
    "upgradeTime": "Det är dags för en uppgradering!",
    "upgradeHigher": "Uppgradera till ett högre abonnemang för att godkänna överföringen av underkontot.",
    "browse": "Utforska abonnemang",
    "pendingTransferTitle": "En överföringsförfrågan för det här underkontot väntar redan.",
    "unableTransfer": "Det går inte att överföra underkontot till denna byrå.",
    "unableEjectCancel": "Det gick inte att avbryta begäran om att göra underkontot fristående.",
    "EjectErrorDetails": "Begäran om att göra underkontot fristående kan inte avbrytas.",
    "hippaErrorDescription": "Detta underkonto är HIPAA-aktiverat och kan inte överföras till en icke-HIPAA-byrå.",
    "pendingTransferErrorDescription": "Avbryt den befintliga överföringsförfrågan för detta underkonto innan du skapar en ny.",
    "receivingAgency": "Mottagande byrå",
    "releasingAgency": "Utfärdande byrå",
    "noOfContacts": "Totalt antal kontakter",
    "requestedDate": "Datum för förfrågan",
    "action": "Åtgärd",
    "cancelTransfer": "Avbryt överföring",
    "decline": "Neka",
    "cancelTransferRequest": "Avbryt förfrågan om överföring av underkonto?",
    "cancelEjectRequest": "Avbryt begäran om att göra underkontot fristående?",
    "cancelRequestDescription": "Den mottagande byrån kommer inte längre att se denna överföringsförfrågan och underkontot {name} överförs inte.",
    "cancelEjectRequestDescription": "Den valda användaren kommer inte längre att kunna skapa en ny byrå från underkontot {name}.",
    "declineRequest": "Avböj förfrågan om överföring av underkonto?",
    "declineRequestDescription": "Förfrågan avböjs och underkontot {name} överförs inte till din byrå.",
    "approveTransfer": "Godkänn överföring av underkonto till din byrå?",
    "approveTransferDescription": "Underkontot {name} överförs till din byrå.",
    "transferNow": "Överför nu",
    "cancelNow": "Avbryt nu",
    "transferErrorDetails": "Detta underkonto kan inte överföras.",
    "cancelRequest": "Avbryt förfrågan",
    "received": "Mottagen",
    "approve": "Godkänn",
    "goBack": "Gå tillbaka",
    "done": "Klar",
    "subAccountTransferred": "Underkontot har överförts!",
    "subAccountTransferDescription": "Även om underkontot har överförts kan det ta 10–15 minuter innan vissa tillgångar, till exempel användare, telefonnummer, Mailgun-konton, Yext-listor etc. visas på destinationen.",
    "activeSubscriptionsAlert": "Platsen har Dynamisk Abonnemang. Vänligen Avbryt varje Abonnemang Före Blind överföring av plattformarna. Lista på Dynamisk Abonnemang: {subscriptions}",
    "isSaasEnabled": "SaaS aktiverat",
    "typeToSearch": "Skriv för att söka",
    "dateAdded": "Tillagd den",
    "emailEngagement": "E-postengagemang",
    "emailReaction": "E-postreaktion",
    "emailDeliverySummary": "Sammanfattning av e-postleverans",
    "facebook": "Facebook",
    "sms": "SMS",
    "instagram": "Instagram",
    "accountSummarySubAccount": "Kontoöversikt – {subAccountName}",
    "test": "Test",
    "scheduleExists": "Schema finns",
    "aToZ": "A–Ö",
    "zToA": "Ö – A",
    "onlyAdminUsersCanAddNewSubAccounts": "Endast adminanvändare kan lägga till nya underkonton.",
    "locationName": "Platsnamn",
    "transferCompleted": "Överföringsbegäran för denna plats har redan behandlats. Uppdatera sidan.",
    "unauthorizedTransfer": "Du är inte behörig att utföra denna Åtgärd. Endast Byråägare kan utföra denna Åtgärd.",
    "bulkLocationTransfer": "Massöverför underkonton",
    "singleRequest": "Enskild begäran",
    "bulkRequest": "Bulk-förfrågan",
    "backToLocationTransfer": "Återgå till platsöverföring",
    "initiateBulkTransfer": "Initiera massöverföring av underkontot",
    "initiateBulkTransferDescription": "Välj de underkonton du vill överföra, eller ange deras ID:n separerade med kommatecken.",
    "subAccountId": "Underkonto-ID",
    "selectFromList": "Välj från listan",
    "addManually": "Lägg till manuellt",
    "accountsSelected": "{count} markerade",
    "selectAllSubAccounts": "Välj varje",
    "removeAll": "Ta bort alla",
    "addManualLocations": "Lägg till plats-ID:n separerade med kommatecken",
    "manualAllLocationIds": "Plats IDs av the sub-Konto Du wish to Överför, Separerad Via kommatecken.",
    "enterLocationIds": "Ange plats-ID:n",
    "selectSubAccounts": "Välj underkonton och överför dem till en befintlig byrå",
    "subAccountTransferWarning": "Varje underkonto-tillgångar och Användare kommer att få Blind överföring.",
    "proceed": "Fortsätt",
    "bulkRequestSubmitted": "Begäran om massöverföring har skickats",
    "bulkRequestSubmittedDescription": "Varje underkonto kommer att överföras när den mottagande byrån accepterar överföringsförfrågan. Du kan följa statusen för begäran på sidan {pagename}. (förutsatt att de är berättigade)",
    "bulkTransferRequestFailed": "Begäran om massöverföring misslyckades",
    "errorLocations": "Underkonton med fel",
    "viewDetails": "Visa detaljer",
    "somethingWrong": "Något gick fel. Försök igen.",
    "confirmBulkRequest": "Bekräfta förfrågan om bulköverföring?",
    "bulkTransferAccounts": "Massöverföring av {count} valda underkonton?",
    "confirmDetails": "Bekräfta detaljer innan du överför.",
    "transferConsent": "Jag har Läs och förstått ovanstående guide och Samtycke till varje begränsningar.",
    "transferInfo": "Överföring av underkonto är beroende av att den mottagande byrån accepterar det till sitt konto.",
    "receivingRelNo": "Mottagande byrås relationsnummer",
    "enterRelNo": "Ange relationsnummer",
    "transferConfirmation": "När du har slutfört denna Åtgärd skickas Bulk Överför Förfrågningar till Mottagen Byrå ({ relNo }). Varje sub-Konto Du've Markerad kommer att bli Blind överföring när Mottagen Byrå godkänner den. Vänligen Anteckning att denna Åtgärd är oåterkallelig för varje underkonto som ingår in Överför.",
    "confirmPassword": "Bekräfta Via att skriva password under",
    "enterPassword": "Ange lösenord",
    "requestTransfer": "Begär överföring",
    "confirmTransfer": "Bekräfta överföring",
    "notNow": "Inte nu",
    "invalidRelNo": "Ogiltigt relationsnummer",
    "invalidPassword": "Ogiltigt password.",
    "searchSubAccounts": "Sök efter underkonton",
    "searchSubAccountsId": "Sök underkonto-ID",
    "takeAction": "Vidta åtgärder",
    "sub_account_details": "Information om underkonto",
    "no_of_contacts": "Totalt antal kontakter",
    "transfer_status": "Överföringsstatus",
    "error_info": "Felinformation",
    "bulk_transfer_status": "Status för bulköverföring av underkonton",
    "pending": "Väntar",
    "processed": "Bearbetad",
    "reject_all": "Avvisa alla",
    "accept_all": "Acceptera alla",
    "cancel_all": "Avbryt alla",
    "clearAll": "Rensa alla",
    "refresh": "Uppdatera",
    "rejected": "Avböjde",
    "decline_transfer": "Avböj överföring",
    "decline_bulk_transfer": "Avböj förfrågan om massöverföring av underkonton?",
    "decline_bulk_transfer_description": "Förfrågan kommer att avböjas och de {length} underkontona kommer inte att överföras till din byrå.",
    "accept_bulk_transfer": "Acceptera begäran om bulköverföring av underkonto?",
    "accept_bulk_transfer_description": "Förfrågan kommer att accepteras och {length} underkonton överförs till din byrå.",
    "cancel_bulk_transfer": "Avbryta bulköverföring?",
    "cancel_bulk_transfer_description": "Är du säker på att du vill avbryta denna bulköverföring av {length} underkonton till {name}?",
    "consent_sub_account_transfer": "Vänligen Läs och Samtycke till {link}",
    "sub_account_transfer_guidelines": "Riktlinjer för överföring av underkonton",
    "valid_rel": "Ange ett giltigt siffra",
    "something_went_wrong": "Något gick fel. Försök igen.",
    "export": "Exportera",
    "export_success": "Uppgifterna som Du begärde behandlas. Du kommer att Ärv ett E-posta med uppgifterna in något Datum.",
    "export_failed": "Uppgifterna som Du begärde kunde inte behandlas. Försök igen senare.",
    "selectAllError": "Du kan endast välja 1 000 underkonton åt gången.",
    "max1000": "(Max 1 000)",
    "subAccountCount": "Antal underkonton",
    "whatsapp": "WhatsApp",
    "scheduleBulkPauseConfirm": "Är du säker på att du vill pausa {count} rapporter?",
    "scheduleBulkResumeConfirm": "Är du säker på att du vill Återuppta {count} -rapporter?",
    "resume": "Återuppta",
    "pause": "Pausa",
    "resumeSelected": "Återuppta Markerad",
    "pauseSelected": "Pausa Markerad",
    "bulkActions": "Bulk actions",
    "xReportsSelected": "{count} rapporter valda",
    "selectAllXReports": "Välj alla {count} rapporter",
    "scheduleStatus": "Schemastatus",
    "scheduleSearchPlaceholder": "Sök med e-post eller platsnamn",
    "subAccountsPerPage": "Underkonton per sida",
    "previous": "Föregående",
    "scheduleBulkAction": "Schemalägg bulkåtgärd",
    "all": "Alla",
    "active": "Aktiv",
    "paused": "Pausad",
    "scheduleUpdatedSuccessfully": "schema Uppdaterad framgångsrikt",
    "saveChanges": "Spara ändringar",
    "pauseSchedulesTitle": "Det rapporterar Pausa Aktiv Schemalagd",
    "pauseSchedulesDescription": "klicka för att rapportera Pausa nu Aktiv.",
    "pauseSchedulesAlert": "Detta påverkar endast Konto som är nu Dynamisk.",
    "pauseAllSchedulesBtnText": "Pausa alla schemalagda rapporter",
    "autoScheduleTitle": "Automatisk schemaläggning för nya konton",
    "autoScheduleLabel": "Skapa automatiskt schemalagda rapporter när ett nytt underkonto läggs till.",
    "autoScheduleAlert": "Inaktivera detta Om Du vill manuellt Konfigurera för Ny Konto.",
    "autoScheduleEnabledForNewAccounts": "Auto-Schemalägg Aktiverad för Ny Konto",
    "autoScheduleDisabledForNewAccounts": "Auto-Schemalägg Inaktiverad för Ny Konto",
    "deleted": "Raderad",
    "locationPaused": "Plats pausad",
    "scheduleSettingsModalTitle": "schemarapport Inställningar",
    "selectAllSchedules": "Välj varje Schemalägg",
    "selectScheduleForLocation": "Välj schema för {location}",
    "openSettings": "Öppna Inställningar",
    "resumeScheduleForLocation": "Återuppta schema för {location}",
    "pauseScheduleForLocation": "Pausa schema för {location}",
    "actions": "Åtgärder",
    "deselectAll": "Avmarkera varje",
    "scheduleBulkActionResumeSuccess": "Bulk -aktivering in — Paus Inaktiverad På Nya aktiviteter",
    "scheduleBulkActionPauseSuccess": "Pausar rapporter – vänta innan du vidtar fler åtgärder",
    "bulkActionCreationError": "En annan massåtgärd pågår. Försök igen om ett ögonblick.",
    "bulkActionInProgress": "Bulk Åtgärd redan in gång",
    "scheduledReports": "Schemalagd rapporter",
    "scheduleBulkActionCompleted": "Bulk Åtgärd Klar framgångsrikt",
    "pauseAllSchedulesModalTitle": "Vill du pausa rapporterna?",
    "pauseAllSchedulesModalText": "Detta kommer att pausa alla aktiva schemalagda rapporter över underkonton.",
    "addLocationIdsPlaceholder": "Lägg till plats-ID:n som du vill överföra …",
    "helloWorld": {
      "count": "Antalet är {count}",
      "editIntro": "Redigera",
      "editAction": "För att testa HMR",
      "checkOut": "Se",
      "officialStarter": ", den officiella Vue + Vite-startversionen",
      "install": "Installera",
      "installDescription": "I din IDE för att få en bättre användarupplevelse",
      "learnMore": "Klicka på Vite- och Vue-logotyperna för att läsa mer"
    },
    "home": {
      "testMessage": "Hej! Detta är en testhemsida!"
    },
    "reports": {
      "incoming": "Inkommande",
      "outgoing": "Utgående",
      "duration": "Varaktighet",
      "contactsCount": "Totalt antal kontakter",
      "appointmentsCount": "Totala möten",
      "formSubmissions": "Inlämnade formulär",
      "surveySubmissions": "Inlämnade undersökningar",
      "facebookFormSubmissions": "Inlämnade Facebook-formulär",
      "funnels": "Trattar",
      "websites": "Webbplatser",
      "forms": "Formulär",
      "surveys": "Undersökningar",
      "gbpMessages": "GBP-meddelanden",
      "facebookMessages": "Facebook-meddelanden",
      "instagramMessages": "Instagram-meddelanden",
      "reviews": "Recensioner",
      "positives": "Positiva",
      "negatives": "Negativa"
    },
    "timeOptions": {
      "00": "00:00",
      "01": "01:00",
      "02": "02:00",
      "03": "03:00",
      "04": "04:00",
      "05": "05:00",
      "06": "06:00",
      "07": "07:00",
      "08": "08:00",
      "09": "09:00",
      "10": "10:00",
      "11": "11:00",
      "12": "12:00",
      "13": "13:00",
      "14": "14:00",
      "15": "15:00",
      "16": "16:00",
      "17": "17:00",
      "18": "18:00",
      "19": "19:00",
      "20": "20:00",
      "21": "21:00",
      "22": "22:00",
      "23": "23:00"
    },
    "transferStatus": {
      "pending": "Väntar",
      "processed": "Bearbetad",
      "canceled": "Avbokad",
      "cancelled": "Annullerad",
      "completed": "Slutförd",
      "rejected": "Avböjd",
      "failed": "Misslyckad",
      "payment_pending": "Betalning väntar"
    }
    }
